import { render, staticRenderFns } from "./pd-accordian.vue?vue&type=template&id=7b1b3307&"
import script from "./pd-accordian.vue?vue&type=script&lang=js&"
export * from "./pd-accordian.vue?vue&type=script&lang=js&"
import style0 from "./pd-accordian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,ShippingTimer: require('/opt/build/repo/storefront/components/legacy/global/shipping-timer.vue').default,ProductImg: require('/opt/build/repo/storefront/components/legacy/global/product-img.vue').default,Slider: require('/opt/build/repo/storefront/components/legacy/global/slider.vue').default,ReviewStars: require('/opt/build/repo/storefront/components/molecules/Review/ReviewStars.vue').default,SecondaryButton: require('/opt/build/repo/storefront/components/atoms/Button/SecondaryButton.vue').default})
